import { classNames, legacyContractDataAttrs } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { useEditorSurface } from '../../EditorSurfaceContext'
import { RecipientCompatControls } from './RecipientCompatControls'
import { RecipientList } from './RecipientList'
import { RecipientSmartInput } from './RecipientSmartInput'

// Recipients ("To:") — legacy look; visual classes come from the surface skin.
// Hook classes stay stable because legacy/facade code still addresses sub-parts.
export function RecipientsBlock() {
  const { skin } = useEditorSurface()
  return (
    <div {...legacyContractDataAttrs('editor.recipients.root')} className={classNames('md-to', skin.recipients.root)}>
      <span className={classNames('md-to__label', skin.recipients.label)}>To:</span>
      <div className={classNames('md-to__field', skin.recipients.field)}>
        <RecipientList />
        <RecipientSmartInput />
        <RecipientCompatControls />
      </div>
    </div>
  )
}
